
/* injects from baggage-loader */

export const initFeedbackTexts = [
    '<big class="uppercase">Essa não!</big> <br>Os <b>turistas</b> jogaram <b>lixo</b> nas <b>trilhas</b>. Ajude o <b>Tamanduá</b> a chegar ao formigueiro indicando o <b>melhor caminho</b>.'
];

export const feedbackTexts = [
    'Agora precisamos saber todos os <b>passos</b> que o <b>tamanduá</b> deu procurando o <b>formigueiro</b>.',
    'Responda as perguntas <b>somando</b> as <b>quantidades de passos</b> dentro de cada <b>quadradinho</b>.'
];

const helpImg = require('_images/stage-helps/tamandua.png');

export const helpTpl = `
    <div class='container-fluid'>
        <div class='row'>
            <div class='col-xs-7'>
                <img src='${helpImg}' class='img-responsive' />
            </div>
            <div class='col-xs-5 text-left'>
                <div class='container-fluid'>
                    <p class='subtitle'>Para <b>ajudar</b> o <b>tamanduá-bandeira</b> a chegar até o <b>formigueiro</b> você deve usar as <b>setas do teclado</b>. Em seguida, observe o <b>trajeto</b> feito e responda as <b>perguntas</b>.</p>
                    <p class='subtitle'><b>ATENÇÃO</b></p>
                    <p class='subtitle'>Para indicar uma posição (coordenada) você deve anotar primeiro a <b>letra</b> e depois o <b>número</b> correspondente a cada <b>quadradinho</b>.</p>
                    <p class='subtitle'><b>Por exemplo:</b> na imagem ao lado, o tamanduá está na <b>posição C3</b>.</p>
                    <p class='subtitle'>Vamos lá</p>
                </div>
            </div>
        </div>
    </div>
`;

export const feedbackFinishStage = [
    'Graças aos seus <b>esforços</b> nesta <br> missão, você ganhou a Medalha Oficial de <b>PROTETOR DA FLORESTA</b>!',
    'Você também será recompensado com <b>1/4 do distintivo</b> de <b>Guardião da Natureza</b>. para completá-lo, você precisa <b>concluir</b> as <b>outras</b> missões. Preparado?',
]


// WEBPACK FOOTER //
// ./src/app/pages/stage-four/stage-four.const.js